// src/components/pages/AppHome.jsx
import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaCircle } from "react-icons/fa";

import ImageCarousel from "../components/pages/imageCarousel.js";
import HomePage from "./pages/homepage.js";
import InstagramPreview from "./pages/InstagramPreview.js";
import FooterHomeUno from "../layouts/footerHomeUno";
import imgLogIn from "../assets/images/logocolegio.png";

function AppHome() {
  return (
    <div className="home-shell d-flex flex-column align-items-center">
      {/* Carrusel principal */}
      <ImageCarousel />

      {/* Presentación con imagen y mensaje */}
      <Container className="home-welcome">
        <Row className="justify-content-center align-items-center text-center">
          <Col xs={12} md={4} className="mb-4 mb-md-0 d-flex justify-content-center imglogin">
            <Image src={imgLogIn} alt="Colegio Santo Tomás" fluid id="img-fluid-css" className="home-welcome-logo" />
          </Col>

          <Col xs={12} md={6} data-aos="zoom-in" className="mt-0 pt-0">
            <h2 className="home-welcome-title fw-bold display-5">
              <span className="text-inicio-home">Bienvenidos al</span>
              <br />
              <span className="text-home home-school-name">
                <span>Colegio</span>
                <span>Santo Tomás</span>
              </span>
            </h2>
            <p className="home-welcome-copy lead">
              Formamos personas para una sociedad más justa y humana, con una propuesta cercana que integra
              conocimiento, valores y comunidad.
            </p>
            <div className="home-welcome-divider" />
            <div className="mt-4 d-flex justify-content-center">
              <Link
                to="/admision"
                className="btn home-admission-btn btn-lg rounded-pill fw-bold d-flex align-items-center justify-content-center gap-2 text-white"
              >
                <FaCircle />
                ADMISIONES
              </Link>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Contenido extendido y footer */}
      <HomePage />
      <InstagramPreview />
      <FooterHomeUno />
    </div>
  );
}

export default AppHome;
